// removed by extract-text-webpack-plugin
module.exports = {"dialog":"attachmentView-module-dialog-2d45c764da11dd03caf82afed8d4aaf7--","overlay-container":"attachmentView-module-overlay-container-f55e891d80211bb4892aa999cd35923a--","attachment-img":"attachmentView-module-attachment-img-7b2e61f65f039c1b7919abe0d9ab7f76--","marketing-img":"attachmentView-module-marketing-img-35c41a6ced3275c01e759e1eb746e506--","close-icon":"attachmentView-module-close-icon-ab1821db1edf0f3a88ab0d033e3375f4--"};


//////////////////
// WEBPACK FOOTER
// /src/components/commonComponents/attachmentView/attachmentView.module.scss
// module id = 1930
// module chunks = 0